import { BarChart3, Sparkles, ChevronRight } from 'lucide-react';

export default function Assessment() {
  return (
    <div className="max-w-2xl mx-auto space-y-8 py-8">
      <div className="text-center space-y-4">
        <div className="w-16 h-16 bg-neutral-900 text-white rounded-2xl flex items-center justify-center mx-auto shadow-xl shadow-neutral-900/20">
          <BarChart3 className="w-8 h-8" />
        </div>
        <h1 className="text-3xl font-bold tracking-tight">Industry Assessment</h1>
        <p className="text-neutral-500 dark:text-neutral-400">Find the perfect industry match for your business using our AI-driven assessment tool.</p>
      </div>

      <div className="bg-white dark:bg-neutral-900 p-8 rounded-[2.5rem] border border-neutral-200 dark:border-neutral-800 shadow-sm dark:shadow-none space-y-6">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center text-sm font-bold">1</div>
            <h3 className="font-bold">Business Goals</h3>
          </div>
          <p className="text-sm text-neutral-600 dark:text-neutral-300">What are your primary objectives for the next 12 months?</p>
          <div className="grid grid-cols-1 gap-2">
            {['Rapid Growth', 'Market Stability', 'Innovation', 'Cost Efficiency'].map((goal) => (
              <button key={goal} className="w-full text-left px-4 py-3 rounded-xl border border-neutral-100 dark:border-neutral-800 hover:border-neutral-900 transition-all text-sm font-medium">
                {goal}
              </button>
            ))}
          </div>
        </div>

        <button className="w-full bg-neutral-900 text-white py-4 rounded-2xl font-bold flex items-center justify-center gap-2 hover:bg-neutral-800 transition-all shadow-lg shadow-neutral-900/20">
          Next Step
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      <div className="flex items-center justify-center gap-2 text-xs font-bold text-neutral-400 dark:text-neutral-500 uppercase tracking-widest">
        <Sparkles className="w-3 h-3" />
        Powered by Messego AI
      </div>
    </div>
  );
}
